import I18n from "i18n-js";
import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, Text, TouchableOpacity, View } from "react-native";

import DependencyAvatarWithDetail from "./DependencyAvatarWithDetail";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

export default class DependencyItem extends React.Component {
  static propTypes = {
    fullName: PropTypes.string.isRequired,
    cardNumber: PropTypes.string.isRequired,
    gender: PropTypes.oneOf(["f", "m", ""]).isRequired,
    onSelect: PropTypes.func.isRequired,
  };

  render() {
    const { fullName, cardNumber, gender, onSelect } = this.props;

    return (
      <View style={styles.container}>
        <DependencyAvatarWithDetail
          fullName={fullName}
          cardNumber={cardNumber}
          gender={gender}
        />
        <TouchableOpacity
          onPress={() => {
            onSelect(cardNumber);
          }}
          style={styles.selectButton}
        >
          <Text style={styles.selectText}>{I18n.t("prixa.select")}</Text>
        </TouchableOpacity>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
    flexDirection: "row",
  },
  selectButton: {
    backgroundColor: staticColors.forestFern,
    borderRadius: 20,
    margin: 10,
    paddingHorizontal: 20,
    paddingVertical: 5,
  },
  selectText: {
    color: staticColors.white,
    fontSize: 18,

    ...fonts.regular,
  },
});
